import { get } from './httpClient';

/**
 * GET /getcollectionactivity?list_id= o ?project_id=.
 * Solo dueño o editor de esa colección. Visitante → 404.
 *
 * @param {{ listId?: string, projectId?: string, limit?: number, before?: string }} query
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function getCollectionActivity(query = {}, { signal } = {}) {
  const list_id = String(query.listId || query.list_id || '').trim();
  const project_id = String(query.projectId || query.project_id || query.id || '').trim();
  if (list_id && project_id) {
    return { data: [], total: 0, has_more: false, _httpOk: false, _httpStatus: 400 };
  }
  if (!list_id && !project_id) {
    return { data: [], total: 0, has_more: false, _httpOk: false, _httpStatus: null };
  }
  const limitRaw = Number(query.limit);
  const limit = Number.isFinite(limitRaw)
    ? Math.min(50, Math.max(1, Math.trunc(limitRaw)))
    : undefined;
  const before = String(query.before || '').trim();
  return get('/getcollectionactivity', {
    params: {
      ...(list_id ? { list_id } : { project_id }),
      ...(limit ? { limit } : {}),
      ...(before ? { before } : {}),
    },
    signal,
  });
}
